module.exports = "<div class=\"flex footer\">\n  <p>Copyright © 2012-2025 Savyasasy Software Solutions Pvt Ltd</p>\n</div>\n"